import Moment from 'moment'
import Store from '../../store'

// @see https://momentjs.com/docs/#/displaying/format/
const defaultDateFormat = 'YYYY/DD/MM'
const defaultTimeFormat = 'hh:mm:ss A'

const getDateFormat = function () {
  // Obtain the formatting for the language we've chosen.
  let lang = Store.getters.getCurrLanguage
  let translations = require('../translate/' + lang.iso + '.js')

  if (!translations.default || !translations.default['dateFormat']) {
    return defaultDateFormat
  }
  return translations.default['dateFormat']
}

const getTimeFormat = function () {
  // Obtain the formatting for the language we've chosen.
  let lang = Store.getters.getCurrLanguage
  let translations = require('../translate/' + lang.iso + '.js')

  if (!translations.default || !translations.default['timeFormat']) {
    return defaultTimeFormat
  }
  return translations.default['timeFormat']
}

export default {

  formatDate (date, f = null) {
    const m = Moment(date, Moment.ISO_8601)
    if (f === null) {
      f = getDateFormat()
    }

    return m.format(f)
  },

  formatTime (date, f = null) {
    if (!Moment.isMoment(date)) {
      console.log('no date')
      return '-'
    }

    if (f === null) {
      console.log('no format')
      f = getTimeFormat()
      console.log('got format', f)
    }

    return date.format(f)
  },

  formatDateTime (date, f = null) {
    const m = Moment(date, Moment.ISO_8601)
    if (f === null) {
      f = getDateFormat() + ' ' + getTimeFormat()
    }

    return m.format(f)
  }
}



// WEBPACK FOOTER //
// ./src/filters/date/index.js